import {useMemo} from 'react';
import {useTranslation} from 'react-i18next';

import {Icon, IconName, Tooltip} from 'components';
import {TRANSLATION_KEYS} from 'locale';
import {SessionNote, SessionNoteAccess} from 'types';
import {buildTranslationKey} from 'utils/transform';

const T_KEYS = TRANSLATION_KEYS.IN_SESSION_PAGE.NOTES_SIDEBAR;

type Props = {
    note: SessionNote;
    onDelete: (id: string) => void;
}

export const NoteItem: React.FC<Props> = ({note, onDelete}) => {
    const {t} = useTranslation();

    const iconName: IconName = useMemo(() => note.access === SessionNoteAccess.Public ? 'eye' : 'eye-off', [note]);

    const iconTooltip = useMemo(() => {
        const key = buildTranslationKey(note.access);
        return t(T_KEYS.ACCESS_TOOLTIP[key]);
    }, [note, t]);

    return (
        <div className='tw-flex tw-justify-between tw-my-4 tw-border tw-border-default tw-p-4 tw-rounded-lg'>
            <div className='tw-break-words tw-overflow-hidden'>{note.message}</div>
            <div className='tw-ml-2'>
                <Tooltip message={iconTooltip}><Icon name={iconName} className='tw-mb-1' /></Tooltip>
                <Icon name='delete' color='alert' button onClick={() => onDelete(note.id)} />
            </div>
        </div>
    );
};